<script>

import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";

export default {
  page: {
    title: "Transaction Code Checkers Queue",
    meta: [{ name: "Till Checkers Queue", content: window.__env.app.description }]
  },
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
      title: "Transaction Code Checkers Queue",
      items: [
        {
          text: "Transaction Code",
          href: "/"
        },
        {
          text: "Transaction Code Checkers Queue",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Transaction Code Checkers Queue</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <TransactionCodeCheckersQueueTable />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
